import { fromJS } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  links: {},
});

// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHED_TOPIC:
      return state.mergeIn(['links'], fromJS(action.payload.entities.links));

    default:
      return state;
  }
};
